export enum ComboSlotType {
  DRINKS = 'drinks',
  SIDES = 'sides',
  PICKER_ASPECT = 'pickerAspect',
}
